<template>
  <!-- L'onglet Commandes du membre : où elles en sont, et en passer une pour lui -->
  <div v-if="member && member.id" class="member-orders">
    <headline class="mt-10">{{ $t('onboarding.commissioning.member.button') }}</headline>
    <member-equipment-orders :member="member" embedded />
  </div>
</template>

<script>
import MemberEquipmentOrders from '@pages/Onboarding/Commissioning/MemberEquipmentOrders.vue'

export default {
  components: { MemberEquipmentOrders },

  computed: {
    member() {
      return this.$parent.member ?? null
    },
  },
}
</script>
